module.exports = __webpack_public_path__ + "static/media/img_plan_pro.0a5effae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img_plan_pro.svg
// module id = 385
// module chunks = 0